var _rect, _defs, _defs2, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlobSceneHaikei(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "visual",
    viewBox: "0 0 900 600",
    width: 900,
    height: 600,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 900,
    height: 600,
    fill: "#001220"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad1_0",
    x1: "33.3%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "grad2_0",
    x1: "0%",
    y1: "0%",
    x2: "66.7%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "20%",
    stopColor: "#001220",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "80%",
    stopColor: "#001220",
    stopOpacity: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(900, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 432.7C-46.3 371.3 -92.6 309.8 -162.5 281.5C-232.4 253.1 -325.7 257.7 -374.7 216.3C-423.7 174.9 -428.2 87.5 -432.7 0L0 0Z",
    fill: "#FBAE3C"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 600)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 -432.7C77.9 -422.6 155.8 -412.6 216.3 -374.7C276.9 -336.8 320.2 -271.1 353.3 -204C386.5 -136.9 409.6 -68.5 432.7 0L0 0Z",
    fill: "#FBAE3C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlobSceneHaikei);
export default __webpack_public_path__ + "static/media/blob-scene-haikei.ba94e04dcb99ad626d55587337509ae7.svg";
export { ForwardRef as ReactComponent };